module.exports = __webpack_public_path__ + "static/jeanine-artist-profile-9739023cd42c3022c47c3ff18327051f.jpeg";